"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ewsQueries = void 0;
var utils_1 = require("../utils");
var offer_catalog_1 = require("./offer-catalog");
__exportStar(require("./types"), exports);
exports.ewsQueries = {
    offerCatalog: {
        offer: (0, utils_1.makeQueryWithVars)({
            queryFn: offer_catalog_1.getOfferCatalogOffer,
            queryKey: 'offerCatalogOfferByUuid',
        }),
        offers: (0, utils_1.makeQueryWithVars)({
            queryFn: offer_catalog_1.getOfferCatalogOffers,
            queryKey: 'offerCatalogOffers',
        }),
        productVersion: (0, utils_1.makeQueryWithVars)({
            queryFn: offer_catalog_1.getOfferCatalogProductVersion,
            queryKey: 'offerCatalogProductVersion',
        }),
        productVersions: offer_catalog_1.useProductVersions,
        products: (0, utils_1.makeQuery)({
            queryFn: offer_catalog_1.getOfferCatalogProducts,
            queryKey: 'offerCatalogProducts',
        }),
    },
};
